import { defu } from 'defu';

import type { IRouteWithObj, Map, Route } from './types';

export const routeTreeToDefaultsApplyFactory = <T extends Map = Map>(
  defaultsFactory: () => Map,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  itemProcessAdditional = (_item: IRouteWithObj<T>) => {
    //
  }
) => {
  return (items: Route<T>[]) => {
    const stack = [...items];

    const stackAdd = (items: Route<T>[]) => stack.push(...items);

    while (stack.length) {
      const item = stack.pop();
      if (!item) continue;

      let to = item.to;
      if (typeof to !== 'string') {
        if (!to) {
          to = item.to = {};
        }
        if (typeof to === 'object') {
          const map = defu(to, defaultsFactory());
          for (const k in map) {
            to[k] = map[k];
          }
          itemProcessAdditional(item as IRouteWithObj<T>);
        }
      }

      item.items && stackAdd(item.items);
    }
  };
};
